<template>
    <div class="tab_content">
        <div class="search_box clearfix">
            <div class="search_time search_inputBox">
               <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="起始日期"></el-date-picker>
               ~
               <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <!-- <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.brand_id" clearable placeholder="品牌" @visible-change="getBrandList">
                <el-option v-for="list in brandList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select> -->
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.breed_id" clearable placeholder="品名" @visible-change="getBreedList">
                <el-option v-for="list in breedList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.search.grade_id" clearable placeholder="等级" @visible-change="getGradeList">
                <el-option v-for="list in gradeList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select> -->
            <div class="reset fcolor" @click="reset">重置</div>
            <el-button  class="publicBtn" @click="search">查询</el-button>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isSetCol="true" scene="report.order.product" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list"></tabletem>
        </div>
        <div class="text-center">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="totalCal">
            <div class="totalName">合计：</div>
            <div class="totalNumber" v-if="statistics.out_cube">出库方数：{{statistics.out_cube }}m³</div>
            <div class="totalNumber" v-if="statistics.sales_cube">销售方数: {{statistics.sales_cube }}m³</div>
            <div class="totalNumber" v-if="statistics.sales_amount">销售金额：¥{{statistics.sales_amount }}</div>
            <div class="totalNumber" v-if="statistics.purchase_amount">采购金额：¥{{statistics.purchase_amount }}</div>
            <div class="totalNumber" v-if="statistics.cost_amount">成本费用：¥{{statistics.cost_amount }}</div>
            <div class="totalNumber" v-if="statistics.reduce_amount">优惠金额: ¥{{statistics.reduce_amount }}</div>
            <div class="totalNumber" v-if="statistics.business_expense">营业支出: ¥{{statistics.business_expense }}</div>
            <div class="totalNumber" v-if="statistics.sales_margin">销售毛利: ¥{{statistics.sales_margin }}</div>
        </div>
        <filter-fields :tableData="filter" scene="report.order.product" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
    </div>
</template>
<style scoped lang="scss">
    .totalNumber{margin-right: 10px;}
    .totalName{margin-right: 10px;}
    // .container{ }
</style>
<script>
import tabletem from '../../../components/table.vue'
import pagination from '../../../components/pagination.vue'
    export default {
        components:{
            tabletem,
            pagination
        },
        data(){
            return{
                tableLoading:false,
                start_time: "",
                end_time: "",
                params : {
                    page : 1,
                    per_page : 50,
                    search : {
                        sales_start : "",
                        sales_end : "",
                        breed_id : "",
                        brand_id : "",
                        grade_id : "",
                    }
                },
                last_page : 1,
                current_page : 1,
                total:0,
                statistics : {
                    count  : "",
                    sales_cube  : "",
                    sales_amount  : "",
                },
                brandList : [],
                breedList : [],
                gradeList : [],

                list:[],
                tableCol:[
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售件数",colKey:"count",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售方数",colKey:"sales_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售金额",colKey:"sales_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"采购金额",colKey:"purchase_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"成本费用",colKey:"cost_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售毛利",colKey:"sales_margin",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"毛利率",colKey:"margin_rate",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                filterDialogVisible:false,
                filter:"",
                fields:"",
            }
        },
        mounted(){
            this.start_time = this.$getCurrentMonthStartValueOf();
            this.end_time = new Date();
        },
        methods:{
            exportExcelBill(){
                this.$exportExecl("/erp/export.summarizing.sales.product","销售汇总(品名)",this.params)
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            getList(){
                this.tableLoading = true;
                this.$postColumnList("/erp/report.order.product",this.params,response=>{
                    this.list = response.data.data.list;
                        this.list.forEach(item => {
                            item.sales_cube = Number(item.sales_cube).toFixed(4)
                            item.sales_price = Number(item.sales_price).toFixed(2)
                            item.sales_amount = Number(item.sales_amount).toFixed(2)
                        })

                        this.total = response.data.data.total;
                        this.filter = response.data.data.column;
                        this.fields=","+(response.data.data.fields.join(",")).toString()+",";
                        this.tableCol.forEach(item=>{
                            if(this.fields.indexOf(","+item.colKey+",")!=-1){
                                item.isShow=true;
                            }else{
                                item.isShow=false;
                            }
                        })
                        this.statistics = response.data.data.statistics;
                        this.last_page = response.data.data.last_page;
                        this.$refs.pagination.flag = true;
                        this.tableLoading = false;
                })
            },
            filterConfirm(){
                this.getList()
            },
            search(){
                this.params.search.sales_start = parseInt(this.start_time / 1000) == 0 ? "" : parseInt(this.start_time / 1000);
                this.params.search.sales_end = parseInt(this.end_time / 1000) == 0 ? "" : parseInt(this.end_time / 1000);
                this.tableColCopy = this.$deepClone(this.tableCol);
                if(this.params.page == 1){
                    this.getList();
                } else {
                    this.params.page = 1
                }
            },
            reset(){
                this.start_time = "";
                this.end_time = "";
                this.params.search = {
                    sales_start : "",
                    sales_end : "",
                    breed_id : "",
                    brand_id : "",
                    grade_id : "",
                }
                this.getList()
            },
            // 品名
            getBreedList(visible){
                if(visible){
                    this.$getBreedList().then(res=>{
                        this.breedList = res.data.data;
                    })
                }
            },
            // 品牌
            getBrandList(visible){
                if(visible){
                    this.$getBrandList().then(res=>{
                        this.brandList = res.data.data;
                    })
                }
            },
            // 等级
            getGradeList(visible){
                if(visible){
                    this.$getGradeList().then(res=>{
                        this.gradeList = res.data.data;
                    })
                }
            },

        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.search();
            }
        }
    }
</script>
